// React
import { Card, Col, Row } from 'reactstrap';
import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

// Hooks
import { useLoading } from '../../hook/useLoading';

// components
import { PageWrapper } from '../../components/pageWrapper';
import { ModalInputAnimation } from '../../components/modalInput';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import {
  CreateTypeNotes,
  DeleteTypesNotes,
  GetTypeNotes as typeDispatch,
  UpdateTypeNotes,
} from '../../store/typeNotes/action';
import { FloatButton } from '../../components/floatButton';

// assets
import { DropdownDatatable } from '../../components/dropdownDatatable';

const TypeNotes = () => {
  const [selectNote, setSelectNote] = useState('');

  const [modal_animationLeft, setmodal_animationLeft] = useState(false);

  function tog_animationLeft() {
    setSelectNote('');
    setmodal_animationLeft(!modal_animationLeft);
  }

  const dispatch = useDispatch();
  const history = useHistory();
  const { loadingWithTime } = useLoading();

  const { typeNotes, success } = useSelector((state) => ({
    error: state.TypeNotes.error,
    typeNotes: state.TypeNotes.typeNotes,
    success: state.TypeNotes.successTypeNotes,
  }));

  const handleSubmit = (e) => {
    loadingWithTime(1000);
    if (selectNote === '') {
      e.preventDefault();
      dispatch(CreateTypeNotes(e.target.typeName.value));
      tog_animationLeft();
      // Atualizar plano
    } else {
      e.preventDefault();
      dispatch(
        UpdateTypeNotes({
          id: selectNote.id,
          name: e.target.typeName.value,
        })
      );
      tog_animationLeft();
    }
  };

  const handleDelete = (id) => {
    dispatch(DeleteTypesNotes(id));
  };

  const handleEdit = (values) => {
    const { id, name } = values;

    setmodal_animationLeft(true);

    setSelectNote({
      id: id,
      name: name,
    });
  };

  useEffect(() => {
    dispatch(typeDispatch());
  }, [dispatch, success]);

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Tipo</span>,
      sortable: false,
      width: '30%',
      selector: (cell) => {
        return (
          <React.Fragment>
            <div className="d-flex align-items-center fw-medium ">
              <Link to="#" className="currency_name">
                {cell.name}
              </Link>
            </div>
          </React.Fragment>
        );
      },
    },
  ];

  return (
    <PageWrapper title={'Tipo de Notas de Associados'}>
      <Row>
        <Col xs={12}>
          <Card>
            <DropdownDatatable
              title="Tipos de Notas"
              titleButton="Nova nota"
              pagination
              persistTableHead
              perPage={10}
              isSearchRemote={false}
              data={typeNotes ? typeNotes : []}
              columns={columns}
              actions={[
                {
                  id: 1,
                  name: 'edit',
                  label: 'Editar',
                  onPress: (cellProps) => handleEdit(cellProps),
                  icon: 'la-pen',
                  classNameColorIcon: 'primary',
                },
              ]}
              handleDelete={(cellProps) => handleDelete(cellProps)}
            />
          </Card>
        </Col>
      </Row>
      <ModalInputAnimation
        toogle={tog_animationLeft}
        title={selectNote ? 'Editar Nota' : 'Adicionar Nota'}
        isOpen={modal_animationLeft}
        value={selectNote ? selectNote.name : ''}
        label="Tipo de nota"
        handleSubmit={handleSubmit}
      />

      <FloatButton handleButton={tog_animationLeft} />
    </PageWrapper>
  );
};

export default TypeNotes;
